/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export type IEventCenterEventName = EventCenterEventName | string;

/**
 * Event Center built-in events
 */
export const enum EventCenterEventName {
  /**
   * The event name after the plugin is initialized
   */
  AbilityInitialed = 'abilityInitialed',
  /**
   * Collapse events that expand ContentBlock
   */
  ToggleContentBlock = 'toggleContentBlock',
  /**
   * Events of tab switching in Agent Modal
   */
  AgentModalTabChange = 'agentModalTabChange',
  /**
   * Stealth Changes in Agent Modal
   */
  AgentModalVisibleChange = 'agentModalVisibleChange',
}
